import FiltersDropdown from 'components/TaskAdvanceFilters/FiltersDropdown';
import { WidgetFilterCnt } from 'pages/Dashboards/Widgets/WidgetAdvanceFilter/widgetAdvanceFilter.style';
import { formatFilters } from 'utils/Task/filters';
import {
  checkEmptyFilters,
  validateAdvancedFilter,
} from 'utils/CustomHooks/useTaskFilters/utils';
import { useEditWidget } from 'components/AllDialogs/Dashboards/editWidget/hooks';
import { useParams } from 'react-router-dom';
import { IUpdateWidget, IWidget } from 'pages/Dashboards/interfaces';
import { useWidget } from 'pages/Dashboards/hooks/useWidgets';
import SubmissionsFiltersDropdown from 'pages/Dashboards/Widgets/SubmissionFiltersDropdown/FiltersDropdown';

interface IWidgetAdvanceFilterProps {
  widgetId: string;
  globalFilters?: any;
  hideFilters?: any;
}

// Widget Local Filters.
function WidgetAdvanceFilter({
  widgetId,
  globalFilters,
  hideFilters = null,
}: IWidgetAdvanceFilterProps) {
  const { editWidgetQuery } = useEditWidget();
  const params = useParams();
  const { dashboardId = '' } = params;
  const { getWidgetQuery } = useWidget({
    apiParams: {
      widgetId,
      dashboardId,
      data: { filters: globalFilters },
    },
  });
  const { queryWidgetById } = useWidget({
    apiParams: { dashboardId, widgetId },
  });
  const data: IWidget = queryWidgetById()?.widget;
  const updateWidget = (filters) => {
    const payload: IUpdateWidget = { filters, dashboardId, id: widgetId };
    editWidgetQuery.mutate(payload, {
      onSuccess: (res) => {
        getWidgetQuery.refetch();
      },
    });
  };
  const handleFilterChange = (filters) => {
    const formatedFilters = formatFilters(filters);
    const isFilterValid = validateAdvancedFilter(formatedFilters.filters);
    let finalFilters = undefined;
    if (isFilterValid) {
      finalFilters = filters;
      updateWidget(finalFilters);
    } else if (!isFilterValid && checkEmptyFilters(formatedFilters.filters)) {
      handleClearFilter();
    }
  };
  const handleClearFilter = () => {
    updateWidget({});
  };

  return (
    <WidgetFilterCnt>
      {(data?.entity == 'task' || data?.entity == 'scheduledTask') && (
        <FiltersDropdown
          selectedFilters={data?.filters}
          onChange={handleFilterChange}
          handleClearFilters={handleClearFilter}
          hideFilters={
            hideFilters ||
            'startDate dueDate locations createdDate archived futureStartDate futureDueDate completedDate taskTemplates priority createdBy scheduleFrequency'
          }
        />
      )}
      {data?.entity == 'submission' && (
        <SubmissionsFiltersDropdown
          handleSetAdvancedFilters={handleFilterChange}
          handleClearFilter={handleClearFilter}
          advancedFilters={data?.filters?.filters}
          hideFilters={
            hideFilters || data?.type !== 'table'
              ? 'template duration completedAt completedBy'
              : ''
          }
        />
      )}
    </WidgetFilterCnt>
  );
}

export default WidgetAdvanceFilter;
